import React from 'react';
import { Navigate } from 'react-router-dom';
import { usePortalAuth } from '../../context/PortalAuthContext';

const PortalProtectedRoute = ({ children }) => {
  const { user } = usePortalAuth();

  if (user === null) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-[#FFFBF5] text-stone-500 text-sm">
        Checking session…
      </div>
    );
  }
  if (user === false) {
    return <Navigate to="/login" replace />;
  }
  return children;
};

export default PortalProtectedRoute;
